import React, { createContext, useContext, useState } from "react";

import {
    GameSummaryContextProps,
    GameSummaryContextValues,
} from "../types/contexts";

import { AsyncStatuses } from "../../../../../types/shared";

const GameSummaryContext = createContext<GameSummaryContextValues | null>(null);

export const useGameSummaryContext = () => {
    const context = useContext(GameSummaryContext);
    if (!context) {
        throw new Error(
            "useGameSummaryContext must be used within a GameSummaryProvider",
        );
    }
    return context;
};

export const GameSummaryProvider: React.FC<GameSummaryContextProps> = props => {
    const {
        children,
        game,
        umpireRatings,
        methods,
        homeRoster,
        visitorRoster,
    } = props;

    const [fetchStatus, setFetchStatus] = useState<AsyncStatuses>(undefined);
    const [submitButtonText, setSubmitButtonText] = useState<string>(
        "Update Game Summary",
    );

    const contextValue = {
        game,
        umpireRatings,
        methods,
        homeRoster,
        visitorRoster,
        fetchStatus,
        setFetchStatus,
        submitButtonText,
        setSubmitButtonText,
    };

    return (
        <GameSummaryContext.Provider value={contextValue}>
            {children}
        </GameSummaryContext.Provider>
    );
};
